import { render, staticRenderFns } from "./LiveVideoCall.vue?vue&type=template&id=5a6f7de2"
import script from "./LiveVideoCall.vue?vue&type=script&lang=js"
export * from "./LiveVideoCall.vue?vue&type=script&lang=js"
import style0 from "./LiveVideoCall.vue?vue&type=style&index=0&id=5a6f7de2&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports